// src/storeAPIs/StorePaymentApis.js
import apiClient from "../utils/Http";

// ===== PUBLIC =====
export const storeGetPaymentInfo = () =>
  apiClient.get("api/store/payment-info/");

// ===== STAFF (optional — if you add an update endpoint later) =====
export const storeUpdatePaymentInfo = (data) =>
  apiClient.patch("api/store/payment-info/", data);

